import { gsap } from 'gsap';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin';

gsap.registerPlugin(ScrambleTextPlugin);

// Characters to cycle through while animating.
const SCRAMBLE_CHARS = '!<>-_\\/[]{}—=+*^?#';

// Deduplicate nodes so we do not scramble the same element twice via multiple selectors.
const uniqueNodes = (nodes) => {
  const set = new Set();
  return nodes.filter((node) => {
    if (set.has(node)) return false;
    set.add(node);
    return true;
  });
};

const animateScramble = (el, delay) => {
  const original = (el.textContent || '').trim();
  if (!original) return;

  // Duration scales with text length so longer titles have time to resolve.
  const duration = Math.min(1.6, 0.8 + original.length * 0.035);
  gsap.to(el, {
    duration,
    delay,
    ease: 'power2.out',
    scrambleText: {
      text: original,
      chars: SCRAMBLE_CHARS,
      revealDelay: 0.15,
      tweenLength: Math.min(15, original.length),
      speed: 0.45,
    },
  });
};

export const initTitleScramble = () => {
  // Collect unique title-like nodes across page layouts.
  const selectors = ['.single-title', '.entry-title', '.page-title', '.site-title a', '.site-title'];
  const candidates = selectors.flatMap((selector) => Array.from(document.querySelectorAll(selector)));
  const targets = uniqueNodes(candidates);
  targets.forEach((el, idx) => {
    // Stagger slightly so multiple titles don’t scramble in perfect sync.
    animateScramble(el, idx * 0.08);
  });
};
